import { BaseOperationModel } from '../base-operation-model';

export class MicrosoftOfficeStopAuditResourcesModel extends BaseOperationModel {
}
